import { type BusinessProcessShapeNames } from '../businessProcess/definitions';
import { type ObjectMenuItem } from '../toolbars/ObjectMenu/ObjectMenuController';
import type StylusConnector from './StylusConnector';
import type StylusFrame from './StylusFrame';
import type StylusSvgStamp from './StylusSvgStamp';

export interface StylusDefinition {
  objectType: 'shape';
  shapeName: BusinessProcessShapeNames;
  options: { variant: string };
}

// TODO - this is a bit of an an inadvertent double-up with Stylus.
// consider just using Stylus instances for this
export interface MenuItemDefinition {
  itemType: 'definition'; // discriminate from stylus instances

  // common properties needed to render the item in the menu
  renderIcon(): React.ReactNode;
  description(): string;
  stylusId(): string;
  toolButtonClass?(): string;
  shapeName: BusinessProcessShapeNames;

  // details used to retrieve the stylus - discriminated by objectType. These are passed to the whiteboardController.getStylus method
  stylusDefinition: StylusDefinition;
}

export const isMenuItemDefinition = (
  item: ObjectMenuItem | StylusSvgStamp | StylusConnector | StylusFrame
): item is MenuItemDefinition =>
  'itemType' in item && item.itemType === 'definition';
